import React, { useState } from "react";
import Header from "../components/Header";
import AboutBg from "../assets/images/aboutBg.jpg";
import Breadcrumbs from "../components/Breadcrumbs";
import Counter from "../components/Counter";
import Footer from "../components/Footer";
import MissionIcon from "../assets/icons/mission.svg";
import VisionIcon from "../assets/icons/vision.svg";
import Mission from "../assets/images/mission-img.png";
import vision from "../assets/images/vision-img.png";
import wIcon from "../assets/icons/w-icon.svg";
import E1Icon from "../assets/icons/E1-icon.svg";
import E2Icon from "../assets/icons/E2-icon.svg";
import CIcon from "../assets/icons/C-icon.svg";
import AIcon from "../assets/icons/A-icon.svg";
import RIcon from "../assets/icons/R-icon.svg";
import WhyTrust from "../components/WhyTrust";
import OurTeam from "../components/OurTeam";
import AppointmentForm from "../components/AppointmentForm";

export default function About() {
  const [hovered, setHovered] = useState("about");

  const valueCards = [
    {
      icon: wIcon,
      title: "Wellness First",
      desc: "Every decision we make prioritizes patient well-being.",
    },
    {
      icon: E1Icon,
      title: "Empathy Always",
      desc: "We treat every client like our own family.",
    },
    {
      icon: CIcon,
      title: "Compassion in Action",
      desc: "Genuine care is at the heart of what we do.",
    },
    {
      icon: AIcon,
      title: "Accountability",
      desc: "We are responsible for delivering on our promises.",
    },
    {
      icon: RIcon,
      title: "Respect & Dignity",
      desc: "Every patient deserves to be treated with honor.",
    },
    {
      icon: E2Icon,
      title: "Excellence in Care",
      desc: "We uphold global medical standards.",
    },
  ];

  const breadcrumbItems = [
    {
      label: "Home",
      active: hovered === "home",
      onClick: () => {},
      onMouseEnter: () => setHovered("home"),
      onMouseLeave: () => setHovered(null),
    },
    {
      label: "About Us",
      active: hovered === "about" || hovered === null,
      onClick: () => {},
      onMouseEnter: () => setHovered("about"),
      onMouseLeave: () => setHovered("about"),
    },
  ];
  return (
    <div className="aboutPage">
      <Header />
      {/* hero section */}
      <div className="aboutHeroSection">
        {/* Breadcrumbs */}
        <div className="aboutBreadcrumbWrapper">
          <Breadcrumbs items={breadcrumbItems} />
        </div>

        {/* Background Image */}
        <div
          className="aboutHeroBg"
          style={{ backgroundImage: `url(${AboutBg})` }}
        />

        <div className="aboutHeroOverlay" />

        {/* Hero Content */}
        <div className="aboutHeroContent">
          <p className="aboutHeroSubtitle">About Us</p>
          <h1 className="aboutHeroTitle">About VeriMED</h1>
          <p className="aboutHeroText">
            Premium in-home and virtual care for aging parents in cameroon.
            Peace of mind for families abroad. Care you can trust at home.
          </p>
        </div>
      </div>

      <div className="aboutFullWidth">
        <Counter />
      </div>

      {/* mission and vision */}
      <div className="aboutSection">
        {/* Mission Block */}
        <div className="aboutMissionRow">
          <div className="aboutTextBlock">
            <div className="aboutIconCircle">
              <img src={MissionIcon} />
            </div>
            <p className="aboutBlockTitle">Our Mission</p>
            <p className="aboutBlockText">
              To deliver compassionate, premium, and accessible healthcare to
              seniors in Cameroon, while giving families abroad the peace of
              mind that comes from knowing their parents are in safe, capable
              hands.
            </p>
          </div>

          <div className="aboutImageBlock">
            <img src={Mission} className="aboutBlockImage" />
          </div>
        </div>

        {/* Vision Block */}
        <div className="aboutVisionRow">
          <div className="aboutImageBlock">
            <img src={vision} className="aboutBlockImage" />
          </div>

          <div className="aboutTextBlock">
            <div className="aboutIconCircle">
              <img src={VisionIcon} />
            </div>
            <p className="aboutBlockTitle">Our Vision</p>
            <p className="aboutBlockText">
              To set a new global standard for home-based geriatric care in
              Africa — combining personal connection with medical excellence,
              and making quality healthcare accessible regardless of distance.
            </p>
          </div>
        </div>
      </div>

      {/* our values */}
      <div className="aboutValuesSection">
        <div className="ourvalues_Wrapper">
          {/* Title */}
          <div className="aboutValuesHeader">
            <p className="aboutValuesTitle">Our Values</p>
            <p className="aboutValuesSubtitle">
              From enrollment to real-time updates, every step is designed for
              clarity.
            </p>
          </div>

          {/* Values Grid */}
          <div className="aboutValuesGrid">
            {/* Card */}
            {valueCards.map((value, i) => (
              <div
                key={i}
                className="aboutValueCard"
                style={{
                  gridColumn:
                    i === 0 ? "span 2" : i === 1 ? "span 2" : "span 1",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow =
                    "0px 12px 24px rgba(0,0,0,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0px)";
                  e.currentTarget.style.boxShadow =
                    "0px 6px 16px rgba(0,0,0,0.15)";
                }}
              >
                <img
                  src={value.icon}
                  alt={value.title}
                  className="aboutValueIcon"
                />
                <h3 className="aboutValueTitle">{value.title}</h3>
                <p className="aboutValueDesc">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* why families trust us */}

      <WhyTrust />

      {/* our team */}
      <OurTeam />

      {/* book an appointment */}
      <AppointmentForm />
      <Footer />
    </div>
  );
}
